import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTransformOptions } from 'Core/hooks';
import CustomPropTypes from 'Core/prop-types';

const initData = {
  userId: "",
  vendorName: "",
  location: "",
  status: "Active",
  contactPerson: ""
};

const VendorsAddEditForm = ({ data, onChanges }) => {
  const statusesList = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];
  
  const statusesOptions = useTransformOptions(statusesList, 'value', 'label', '', 'Select Status');

  const [formData, setFormData] = useState(data ? data : initData);

  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => {
      const updatedData = {
        ...prevData,
        [fieldName]: value,
      };
      onChanges(updatedData);
      return updatedData;
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Vendor Name <span className="text-danger">*</span>
            </label>
            <input
              name="vendorName"
              type="text"
              className="form-control"
              value={formData.vendorName}
              onChange={e => updateFormField('vendorName', e.target.value)}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Location
            </label>
            <input
              type="text"
              value={formData.location}
              onChange={e => updateFormField('location', e.target.value)}
              className="form-control"
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Status
            </label>
            <select
              value={formData.status}
              onChange={e => updateFormField('status', e.target.value)}
              className="form-control"
            >
              {statusesOptions.map(option => (
                <option key={option.label} value={option.label}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label>
              Contact Person
            </label>
            <input
              name="contactPerson"
              type="text"
              className="form-control"
              value={formData.contactPerson}
              onChange={e => updateFormField('contactPerson', e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

VendorsAddEditForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape(CustomPropTypes.Vendor),
  onChanges: PropTypes.func,
};

export default VendorsAddEditForm; 